import { render, staticRenderFns } from "./PayoutMethods.vue?vue&type=template&id=7204ca23"
import script from "./PayoutMethods.vue?vue&type=script&lang=js"
export * from "./PayoutMethods.vue?vue&type=script&lang=js"
import style0 from "./PayoutMethods.vue?vue&type=style&index=0&id=7204ca23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports